import { FilterState } from "../../../redux/slices/openData/openDataFiltersSlice";

export const getIdsFromTitles = (filters: FilterState, titles: string[], filterType: 'ods' | 'gruposPrioritarios'): string[] => {
    if (!filters.filterOptions) return [];

    const options = filterType === 'ods'
        ? filters.filterOptions.ods
        : filters.filterOptions.priorityGroups;

    if (!options) return [];

    return titles
        .map(titulo => {
            const option = options.find(opt => opt.titulo === titulo);
            return option?.id?.toString();
        })
        .filter((id): id is string => id !== undefined);
};